<template>
  <div class="content-container">
    <!-- <h6 class="content-header">工作台</h6> -->
    <el-row :gutter="14" class="mt-20">
      <el-col :span="14">
        <div class="home-search">
          <el-select
            v-model="selectQueryResult"
            class="hookiOS"
            filterable
            remote
            reserve-keyword
            :placeholder="placeholder"
            value-key="id"
            :remote-method="search"
            :loading="searchLoading"
            :multiple="isMobile()"
            :multiple-limit="1"
            @change="selectedQueryResult"
            v-if="
              hasAuth('customerList') ||
              hasAuth('orderList') ||
              hasAuth('quotationList')
            "
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
            <el-option-group
              v-for="group in searchResults"
              :key="group.label"
              :label="group.label"
            >
              <el-option
                v-for="item in group.options"
                :key="item.id"
                :label="item.title"
                :value="item"
              >
                <p class="flex-row-between">
                  <span>{{ item.title }}</span>
                  <span>{{ item.subtitle }}</span>
                </p>
              </el-option>
            </el-option-group>
          </el-select>
        </div>
      </el-col>
      <el-col :span="10">
        <div class="actions">
          <h4>快捷操作</h4>
          <div>
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="small"
              @click="startCustomerFormer"
              v-permission="Auth.customerNew"
              >新客户</el-button
            >
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="small"
              @click="startQuotation"
              v-permission="
                userInfo.dealer_id > 0
                  ? Auth.orderNew
                  : Auth.commodityOrderItemUpdate
              "
              >新报价</el-button
            >
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="small"
              @click="startCreateFollowup"
              v-permission="Auth.customerFollowUpNew"
              >拜访记录</el-button
            >
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="14">
      <el-col :span="14">
        <MyServiceQuests v-if="hasAuth('serviceQuestFlow')"></MyServiceQuests>
        <div class="panel mb-20" v-if="approveEvents.length > 0">
          <div class="header flex-row-between">
            <h2>审批消息</h2>
          </div>
          <ul class="messages">
            <li v-for="item in approveEvents" :key="item.id">
              <router-link class="flex-row-between" :to="item.link">
                <span class="content">
                  <span style="flex: 1"
                    >[{{ approveEventTypeMap[item.category] }}]
                    {{ item.content }}</span
                  >
                </span>
                <span class="date">{{ formatTime(item.created_at) }}</span>
              </router-link>
            </li>
          </ul>
          <!-- <div v-else class="text-info-12">暂无审批消息</div> -->
        </div>
        <div class="panel mb-20">
          <div class="header">
            <h2>最近操作客户</h2>
          </div>

          <el-tabs>
            <el-tab-pane label="最近注册" v-if="hasAuth('customerUserList')"
              ><CustomerUserList :isLastList="true"></CustomerUserList
            ></el-tab-pane>
            <el-tab-pane
              label="最近拜访"
              v-if="hasAuth('customerFollowUpList')"
            >
              <ul class="active-customers">
                <li v-for="item in activeVisitCustomers" :key="item.id">
                  <div class="content">
                    <customer-link :customer="item"></customer-link>
                    <div class="font-12" v-if="auth.isPlatformUser()">
                      {{ item.dealer.name }}
                    </div>
                  </div>
                  <div class="type">
                    {{ CustomerLogMap[item.active_type] }}
                    <span class="font-12">
                      {{ formatTime(item.active_time) }}
                    </span>
                  </div>
                </li>
              </ul>
            </el-tab-pane>
            <el-tab-pane label="全部">
              <ul class="active-customers">
                <li v-for="item in activeCustomers" :key="item.id">
                  <div class="content">
                    <customer-link :customer="item"></customer-link>
                    <div class="font-12" v-if="auth.isPlatformUser()">
                      {{ item.dealer.name }}
                    </div>
                  </div>
                  <div class="type">
                    {{ CustomerLogMap[item.active_type] }}
                    <span class="font-12">
                      {{ formatTime(item.active_time) }}
                    </span>
                  </div>
                </li>
              </ul>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-col>
      <el-col :span="10">
        <div class="panel">
          <div class="header flex-row-between">
            <h2>最新消息</h2>
            <router-link to="/dashboard/messages" class="text-primary font-12"
              >全部消息</router-link
            >
          </div>
          <ul v-if="messages.length > 0" class="messages">
            <li v-for="item in messages" :key="item.id">
              <router-link class="flex-row-between" :to="item.link">
                <span class="content">
                  <i :class="{ unread: item.status == 1 }"></i>
                  <span style="flex: 1">{{ item.content }}</span>
                </span>
                <span class="date">{{ formatTime(item.created_at) }}</span>
              </router-link>
            </li>
          </ul>
          <div v-else class="text-info-12">暂无新消息</div>
        </div>
      </el-col>
    </el-row>
    <sale-goal-setter
      :model="saleGoalForm"
      :show.sync="saleGoalSetterVisible"
      @updated="updatedSaleGoal"
    ></sale-goal-setter>
    <customer-collection-former
      :model="customerCollectionForm"
      :order="collectionOrder"
      :show.sync="customerCollectionFormVisible"
      @created="createdCustomerCollection"
    ></customer-collection-former>
    <customer-selector
      :show.sync="customerSelectorVisible1"
      :activeCustomers="activeCustomers"
      @selected="selectedQuotationCustomer"
    ></customer-selector>
    <customer-selector
      :show.sync="customerSelectorVisible2"
      :activeCustomers="activeCustomers"
      @selected="selectedFollowCustomer"
    ></customer-selector>
    <customer-former
      :model="customerForm"
      :show.sync="addCustomerFormVisible"
      @createdCustomer="createdCustomer"
    ></customer-former>
    <followup-former
      :model="followUpForm"
      :show.sync="createFollowupFormVisible"
      @created="createdFollowup"
    ></followup-former>
  </div>
</template>

<script>
import {
  dealerAdminTodoList,
  saleGoalDetail,
  userList,
  saleTodoList,
  dashboardDataReport,
  search,
  messageList,
  customerActiveList,
  approveEventList,
} from '../service/getData'
import {
  TodoTypeMap,
  Monthes,
  CustomerLogMap,
  ApproveEventTypeMap,
} from '@/config/global'
import SaleGoalSetter from '@/components/sale_goal_setter'
import { clone } from '@/util'
import CustomerCollectionFormer from '@/components/customer_collection'
import CustomerFormer from '@/components/customer'
import CustomerSelector from '@/components/customer_selector'
import FollowupFormer from '@/components/followup'
import store from '@/store/store'
import { isMobile, formatTime } from '@/util/index'
import auth from '@/util/auth'
import { hasAuth } from '@/permission'
import { messagesFormat } from '../util'
import MyServiceQuests from '@/components/my_service_quests.vue'
import CustomerUserList from './customer_user/list.vue'

export default {
  components: {
    SaleGoalSetter,
    CustomerCollectionFormer,
    CustomerFormer,
    CustomerSelector,
    FollowupFormer,
    MyServiceQuests,
    CustomerUserList,
  },
  data() {
    return {
      hasAuth,
      isMobile,
      saleGoalSetterVisible: false,
      saleGoalForm: {},
      auth,
      approveEvents: [],
      messages: [],
      sales: [],
      todos: [],
      todoTypeMap: TodoTypeMap,
      approveEventTypeMap: ApproveEventTypeMap,
      selectDateMode: 0,
      selectSale: 0,
      goal: null,
      CustomerLogMap,
      monthes: clone(Monthes),
      dataReport: {},
      todoTypeMap: TodoTypeMap,
      customerCollectionFormVisible: false,
      customerCollectionForm: {},
      collectionOrder: null,
      query: '',
      userInfo: store.getters.userInfo,
      addCustomerFormVisible: false,
      customerForm: {},
      customerSelectorVisible1: false,
      customerSelectorVisible2: false,
      searchLoading: false,
      searchResultVisible: false,
      searchResults: [],
      formatTime,
      selectQueryResult: null,
      followUpForm: {},
      activeCustomers: [],
      createFollowupFormVisible: false,
      activeVisitCustomers: [],
    }
  },
  computed: {
    placeholder() {
      let arr = []

      if (hasAuth('customerList')) {
        arr.push('客户')
      }
      if (hasAuth('orderList')) {
        arr.push('订单号')
      }
      if (hasAuth('quotationList')) {
        arr.push('报价单号')
      }

      let p = ''
      if (arr.length > 0) {
        p = '搜索' + arr.join('、')
      }

      return p
    },
    saleGoalValue() {
      if (!this.goal || this.goal.goals.length == 0) {
        return 0
      }
      let arr = this.goal.goals.split(',')
      return arr[this.selectDateMode] * 10000
    },
    salePercent() {
      if (this.saleGoalValue == 0) {
        return 0
      }
      return Math.min(
        100,
        ((this.dataReport.total_amount || 0) / this.saleGoalValue) * 100
      )
    },
    collectionPercent() {
      return Math.min(
        100,
        ((this.dataReport.collection_amount || 0) /
          (this.dataReport.total_amount || 1)) *
          100
      )
    },
  },
  watch: {
    selectSale() {
      this.requestSaleGoal(this.selectSale)
      this.requestDataReport()
    },
    selectDateMode() {
      this.requestDataReport()
    },
  },
  created() {
    // this.requestSales()
    // this.monthes.unshift('本年')
    // this.requestDataReport()
    // if (!this.auth.isSaleAdmin()) {
    //   this.selectSale = this.userInfo.id
    //   this.requestSaleGoal(this.userInfo.id)
    // } else {
    //   this.requestSaleGoal(0)
    //   this.requestAdminTodoList()
    // }
    // this.requestSaleTodoList()
    this.requestApproveEvents()
    this.requestMessages()
    this.requestActiveVisitCustomer()
    this.requestActiveCustomer()
  },
  mounted() {
    // Array.from(document.getElementsByClassName('el-select')).forEach((item) => {
    //   item.children[0].children[0].removeAttribute('readOnly')
    //   item.children[0].children[0].onblur = function () {
    //     let _this = this
    //     setTimeout(() => {
    //       _this.removeAttribute('readOnly')
    //     }, 250)
    //   }
    // })
  },

  methods: {
    async requestAdminTodoList() {
      let res = await dealerAdminTodoList()
      if (res.code == 0) {
        if (res.data.list) {
          this.todos = this.todos.concat(res.data.list)
        }
      }
    },
    async requestApproveEvents() {
      let res = await approveEventList({ page: 0, size: 50 })
      if (res.code == 0) {
        this.approveEvents = res.data.list.map((item) => {
          switch (item.category) {
            case 1:
              item.link = '/dashboard/quotations/' + item.event_id
              break
            case 2:
              item.link = '/dashboard/shop/pending_orders/' + item.event_id
              break
            case 3:
              item.link = '/dashboard/service_quests/list/' + item.event_id
              break
            case 4:
              item.link = '/dashboard/notice_approve/' + item.event_id
              break
            case 5:
              item.link = '/dashboard/dealer/orders/' + item.event_id
              break
            case 6:
              item.link = '/dashboard/admin/customer_users'
              break
            default:
              break
          }
          return item
        })
      }
    },
    async requestMessages() {
      let res = await messageList({
        size: 5,
        page: 0,
      })
      if (res.code == 0) {
        this.messages = messagesFormat(res.data.list)
      }
    },
    async requestSaleGoal(uid) {
      let data = {
        user_id: uid || 0,
        year: '2020',
      }
      let res = await saleGoalDetail(data)
      if (res.code == 0) {
        this.goal = res.data
      }
    },
    async requestSales() {
      let data = { page: 0, size: 1000 }
      let res = await userList(data)
      if (res.code == 0) {
        this.sales = res.data.list

        this.sales.unshift({
          name: '团队',
          id: 0,
        })
      }
    },
    async requestActiveCustomer() {
      let res = await customerActiveList()
      if (res.code == 0) {
        this.activeCustomers = res.data.list
      }
    },
    async requestActiveVisitCustomer() {
      let res = await customerActiveList({
        is_visit_list: true,
      })

      if (res.code == 0) {
        this.activeVisitCustomers = res.data.list
      }
    },
    startGoalSetter() {
      var goals = []

      if (this.goal && this.goal.goals.length > 0) {
        let garray = this.goal.goals.split(',')
        if (garray.length == 13) {
          goals = garray
        }
      } else {
        while (goals.length < 13) {
          goals.push('')
        }
      }

      var name = ''
      this.sales.map((item) => {
        if (item.id == this.selectSale) {
          name = item.name
        }
      })

      this.saleGoalForm = {
        user_id: this.selectSale,
        year: '2020',
        goals: goals,
        name: name,
      }
      this.saleGoalSetterVisible = true
    },
    async requestDataReport() {
      let data = {
        user_id: this.selectSale,
      }

      if (this.selectDateMode > 0) {
        data.start_date = '2020-0' + this.selectDateMode + '-1T00:00:00'
        data.end_date =
          '2020-0' + (parseInt(this.selectDateMode) + 1) + '-1T00:00:00'
      }

      let res = await dashboardDataReport(data)
      if (res.code == 0) {
        this.dataReport = res.data
      }
    },
    updatedSaleGoal(goal) {
      this.goal = goal
    },
    async requestSaleTodoList() {
      let res = await saleTodoList()
      if (res.data.list) {
        this.todos = this.todos.concat(res.data.list)
      }
    },
    startCollectionFormer(order) {
      this.collectionOrder = order
      this.customerCollectionForm = {
        customer_id: order.customer_id,
        amount: '',
        customer_order_id: order.id,
        date: null,
      }
      this.customerCollectionFormVisible = true
    },
    async search(query) {
      if (query !== '') {
        this.searchLoading = true
        let res = await search({
          query: query,
        })
        let searchResults = []
        if (res.code == 0) {
          let data = res.data
          if (data.customers && data.customers.length > 0) {
            searchResults.push({
              label: '客户',
              options: data.customers,
            })
          }

          if (data.orders && data.orders.length > 0) {
            searchResults.push({
              label: '订单',
              options: data.orders,
            })
          }

          if (data.quotations && data.quotations.length > 0) {
            searchResults.push({
              label: '报价单',
              options: data.quotations,
            })
          }
        }
        this.searchResults = searchResults
        this.searchLoading = false
      } else {
        this.searchResults = []
      }
    },
    startCustomerFormer() {
      this.customerForm = {
        name: '',
        area_id: 0,
        industry: '',
        source: '',
        scale: '',
        remark: '',
        status: 1,
        category: 1,
        area: [],
        address_detail: '',
        sap_code: '',
        special_mark: 0,
      }
      this.addCustomerFormVisible = true
    },
    createdCustomer(customer) {
      this.$router.push('/dashboard/customers/' + customer.id)
    },
    startQuotation() {
      this.customerSelectorVisible1 = true
    },
    selectedQuotationCustomer(customer) {
      let path = '/dashboard/order_editor?customer='
      if (this.userInfo.dealer_id == 0) {
        path = '/dashboard/shop/orders/editor?customer='
      }
      this.$router.push(path + customer.id)
    },
    selectedFollowCustomer(customer) {
      this.followUpForm = {
        customer_id: customer.id,
        customer_name: customer.name,
        type: 1,
        date: null,
        next_date: null,
        amount: '',
        quotation_id: null,
        content: '',
        customer_contact_id: null,
      }
      this.createFollowupFormVisible = true
    },
    createdCustomerCollection() {
      this.todos = []
      this.requestSaleTodoList()
      if (hasAuth('userList')) {
        this.requestAdminTodoList()
      }
      this.requestMessages()
    },
    createdFollowup() {},
    todoContent(todo) {
      switch (todo.type) {
        case 1:
          return (
            todo.model.user.name +
            '申请报价单' +
            this.customerQuotationLink(todo.model) +
            '，请及时审批'
          )
        case 2:
          return (
            todo.model.user.name +
            '请您确认订单' +
            this.customeOrderrLink(todo.model)
          )
        case 3:
          return (
            '计划今日与客户' +
            this.customerLink(todo.model.customer) +
            '沟通报价'
          )
          break
        case 5:
          return (
            todo.model.customer.name +
            '订单' +
            this.customeOrderrLink(todo.model) +
            '剩余￥' +
            parseFloat(
              todo.model.amount - todo.model.collection_amount
            ).toFixed(2) +
            '回款'
          )
          break
        case 6:
          return '客户' + this.customerLink(todo.model) + '已逾20天未进行拜访'
        default:
          break
      }
    },
    customerLink(customer) {
      return (
        '<a href="/dashboard/customers/' +
        customer.id +
        '">' +
        customer.name +
        '</a>'
      )
    },
    customeOrderrLink(order) {
      return (
        '<a href="/dashboard/dealer/orders/' +
        order.id +
        '">' +
        order.number +
        '</a>'
      )
    },
    customerQuotationLink(q) {
      return '<a href="/dashboard/quotations/' + q.id + '">' + q.number + '</a>'
    },
    selectedQueryResult() {
      let type = this.selectQueryResult.type
      let id = this.selectQueryResult.id

      if (this.isMobile()) {
        type = this.selectQueryResult[0].type
        id = this.selectQueryResult[0].id
      }

      if (type == 1) {
        this.$router.push('/dashboard/dealer/orders/' + id)
      } else if (type == 2) {
        this.$router.push('/dashboard/quotations/' + id)
      } else if (type == 3) {
        this.$router.push('/dashboard/customers/' + id)
      }
    },
    startCreateFollowup() {
      this.customerSelectorVisible2 = true
    },
    showMessageContent(message) {
      let params = message.params
      if (!params) {
        return ''
      }
      switch (message.type) {
        case 2:
          return (
            '报价单：' +
            params['number'] +
            '（' +
            params['customer_name'] +
            '）已通过审核'
          )
        case 3:
          return (
            '报价单：' +
            params['number'] +
            '（' +
            params['customer_name'] +
            '）未通过审核'
          )
        case 4:
          return (
            '订单：' +
            params['number'] +
            '（' +
            params['customer_name'] +
            '）已确认'
          )
        case 6:
          return (
            '收到订单：' +
            params['number'] +
            '（' +
            params['customer_name'] +
            '）回款￥' +
            params['amount']
          )
        default:
          break
      }
    },
  },
}
</script>

<style scoped>
.current-customer span {
  cursor: pointer;
  margin-right: 10px;
}

.messages li {
  padding: 10px 0;
  color: #555;
}

.messages li .date {
  color: #999;
  width: 100px;
  text-align: right;
}

.messages li .content {
  flex: 1;
  display: flex;
  align-items: center;
}

.messages li .content i {
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-right: 4px;
  border-radius: 4px;
  margin-top: -2px;
}

.messages li .content i.unread {
  background-color: green;
}

input.el-input__inner {
  background-color: rgba(121, 138, 185, 0.07) !important;
}

.data-list {
  margin-top: 20px;
}
.data-list li span {
  display: block;
  text-align: center;
}
.data-list li span.value {
  font-size: 24px;
  font-weight: 500;
}
.data-list li span.title {
  color: #999;
}
.data-item {
  margin-top: 10px;
  color: #888;
  margin-bottom: 3px;
  min-width: 30%;
}
.data-item .value {
  color: #047bf8;
}
.target-item {
  margin: 20px 0 10px;
}
.data-item .target {
  color: #047bf8;
  font-size: 20px;
}
.actions {
  height: 80px;
}
.actions h4 {
  font-size: 14px;
  margin-bottom: 10px;
}
.el-select--mini {
  width: 120px !important;
}

.messages li a {
  color: #333;
}
.active-customers li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 12px;
  border-bottom: 1px solid #eee;
  margin-top: 12px;
}
.active-customers {
  margin-top: 20px;
}
.active-customers li:last-child {
  border-bottom: 0 none;
}
.active-customers li .content {
  flex: 1;
}
.active-customers li .type {
  width: 80px;
  text-align: right;
  color: gray;
  line-height: 1.2em;
}
</style>